import { memo } from 'react';
import styled from 'styled-components';

const StyledTable = styled.table`
  width: 100%;
  height: auto;
  margin: 0;
  padding: 0;
  border-collapse: collapse;
  position: relative;
  display: table;

  /* Modern clean font */
  font-family: "Inter", "Segoe UI", Arial, sans-serif;

  /* Optional compact mode */
  ${({ $compact }) =>
    $compact &&
    `
      font-size: 13px;
  `}

  /* Optional soft border for table container using prop */
  ${({ $bordered }) =>
    $bordered &&
    `
      border: 1px solid #e6e6e6;
      border-radius: 10px;
  `}
`;

const Table = memo(({ children, compact = false, bordered = false }) => (
  <StyledTable $compact={compact} $bordered={bordered}>
    {children}
  </StyledTable>
));

export default Table;
